import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    details_icon: {
        marginLeft: '3px',
        color: theme.palette.warning.main,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        "&:hover": {
            color: theme.palette.warning.dark,
            filter: 'brightness(1.1)',
        }
    },
    popoverContent: {
        padding: theme.spacing(2),
        minWidth: '320px',
        maxWidth: '400px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        borderRadius: theme.spacing(1),
    },
    popoverHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
        paddingBottom: theme.spacing(1.5),
        borderBottom: `2px solid ${theme.palette.warning.main}`,
    },
    popoverWarningIcon: {
        color: theme.palette.warning.main,
        fontSize: '1.5rem',
    },
    popoverTitle: {
        color: theme.palette.warning.main,
        fontWeight: 600,
        fontSize: '1rem',
    },
    popoverBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1.5),
    },
    popoverDescription: {
        color: '#424242',
        marginBottom: theme.spacing(1),
    },
    ordersList: {
        padding: 0,
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.75),
    },
    listItem: {
        padding: 0,
        paddingLeft: theme.spacing(1),
        '&:before': {
            content: '"•"',
            marginRight: theme.spacing(1),
            color: theme.palette.warning.main,
            fontWeight: 'bold',
        },
    },
    orderChip: {
        backgroundColor: `rgba(${theme.palette.warning.main}, 0.1)`,
        borderColor: theme.palette.warning.main,
        color: theme.palette.warning.main,
        fontWeight: 500,
        '& .MuiChip-label': {
            padding: '4px 8px',
        },
    },
    popoverFooter: {
        color: '#757575',
        fontStyle: 'italic',
        marginTop: theme.spacing(1),
        display: 'block',
    },
}));

export { useStyles };
